export const DB_VERSION = 1;

export const CACHE_DB_NAME = 'cache_db';
export const API_CACHE_STORE_NAME = 'api_cache_store';
